export default __webpack_public_path__ + "static/media/image.9bc4a665.svg";